<template>

  <div class="content-wrap">
    <div class="search-wrap">
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="리비전번호">
              <template #end>
                <ElSelect v-model="state.revSelect.selected" :options="state.revSelect.list.map(item => ({text: item.rev_id, value: item.rev_id}))"/>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <!-- {{ state.depth1.list }} -->
            <!-- <ElLabel name="1단계">
              <template #end>
                <ElSelect v-model="state.depth1.selected.class_nm" :options="state.depth1.list.map(item => ({text: item.rev_id, value: item.rev_id}))"/>
              </template>
            </ElLabel> -->
            <label for="" class="form-label">1단계</label>
            <div class="dropdown">
              <ElButton
                type="dropdown"
              >
                {{ state.depth1.selected.class_nm }}
              </ElButton>
              <ul class="dropdown-menu">
                <li v-for="(item, index) in state.depth1.list">
                  <a class="dropdown-item" @click="nextDepth(item, 1)">{{
                    item.class_nm
                  }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <label for="" class="form-label">2단계</label>
            <div class="dropdown">
              <ElButton
                type="dropdown"
              >
                {{ state.depth2.selected.class_nm }}
              </ElButton>
              <ul class="dropdown-menu">
                <li v-for="(item, index) in state.depth2.list">
                  <a class="dropdown-item" @click="nextDepth(item, 2)">{{
                    item.class_nm
                  }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <label for="" class="form-label">3단계</label>
            <div class="dropdown">
              <ElButton
                type="dropdown"
              >
                {{ state.depth3.selected.class_nm }}
              </ElButton>
              <ul class="dropdown-menu">
                <li v-for="(item, index) in state.depth3.list">
                  <a class="dropdown-item" @click="nextDepth(item, 3)">{{
                    item.class_nm
                  }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="search-detail-wrap"></div>

    <div class="text-end py-2">
      <ElButton type="search" @buttonClick="getList()">
        검색
      </ElButton>
    </div>

    <div class="d-flex justify-content-between">
      <div></div>
      <div class="table-btn-group">
        
        <span class="me-2"><b> Total :</b>
            {{
              state.originList.length ? state.originList.length : 0
            }}</span>
        <img data-v-5bf53b0e="" src="/images/vr.png" alt="">
        <ElButton type="excelDownload" @buttonClick="excelDown()">
          엑셀다운
        </ElButton>
        
      </div>
    </div>

    <div class="table-responsive table-list">
      <TreeTable ref="treeTableRef" :data-list="state.originList" :grid-column="state.gridColumn" :editable="false"
        :root-val="state.rootId" @editCol="r => editCell(r)" @editComplete="r => onCellEditComplete(r)" />
    </div>

    <div class="text-end py-3">
      <!-- <ElButton type="primary" @buttonClick="shareToUser">공유하기</ElButton> -->
      <!-- <ElButton  v-if="canUpdate" type="primary" @buttonClick="save()">수정</ElButton> -->
      <ElButton type="primary" @buttonClick="goBack()">이전</ElButton>
    </div>
  </div>
  <!-- 메일발송 모달 (1.컴포넌트) -->
  <EmailSendModal ref="emailSendModalRef" />
  <excelUtil ref="excelUtilRef" v-show="false" />
</template>

<script setup>
import { reactive, onBeforeMount, ref,computed } from "vue";
import routerCmn from "@/js/vueRouterCmn";
import excelUtil from "@/components/common/MCO_EX_001.vue";
import TreeTable from "@/components/common/TreeTable.vue";
import { capture } from "@/js/capture";
import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { prodList, prodEdit, getProdRevIdList } from "@/api/prod";
/** 메일발송 모달 (2.컴포넌트 import 및 참조 선언) */
import EmailSendModal from "@/components/common/modal/EmailSendModal.vue";
import common from "@/js/common";


const excelUtilRef = ref();
const selectByCodeRef = ref();
const refInput = ref();
const emailSendModalRef = ref();
const treeTableRef = ref()

onBeforeMount(async () => {
  await getRevList();

  await getList();
});


const state = reactive({
  gridColumn: [
    {
      header: "상품명",
      field: "class_nm",
      expander: true,
      style: { width : '14%' },
      type: 'text'
    },
    { header: "활성화 여부", field: "enable_yn", type: 'select', cdGr: 'YN_CD', chkEss: 'Y',style: { width : '14%' }},
    { header: "메모", field: "note", type: 'text',style: { width : '16%' }},
    { header: "등록일", field: "fmt_reg_dt",style: { width : '14%' }},
    { header: "등록자", field: "reg_user_nm",style: { width : '14%' }},
    { header: "수정일", field: "fmt_upd_dt",style: { width : '14%' }},
    { header: "수정자", field: "upd_user_nm",style: { width : '14%' }},
  ],
  excelGridColumn1: [
    {header: "상품",rowspan : 1,colspan : 3},
     { header: "상품 버전 ID",rowspan : 2,colspan : 1},
     { header: "상품 ID",rowspan : 2,colspan : 1},
    { header: "활성화 여부",rowspan : 2,colspan : 1},
    { header: "메모",rowspan : 2,colspan : 1},
    { header: "등록일",rowspan : 2,colspan : 1},
    { header: "등록자",rowspan : 2,colspan : 1},
    { header: "수정일",rowspan : 2,colspan : 1},
    { header: "수정자",rowspan : 2,colspan : 1},
  ],
  excelGridColumn2: [
   {header : '1단계',rowspan : 1,colspan : 1},
   {header : '2단계',rowspan : 1,colspan : 1},
   {header : '3단계',rowspan : 1,colspan : 1},
  ],
  gridRowData: [],
  originList: [],
  prodList: [],
  excelData : [],
  selectRows: [],
  firstLoad: true,
  revSelect: {
    selected: "",
    list: [],
  },
  curDepth: 1,
  depth1: {
    selected: { up_class_id: "", class_id: "", class_nm: "All" },
    list: [{ up_class_id: "", class_id: "", class_nm: "All" }],
  },
  depth2: {
    selected: { up_class_id: "", class_id: "", class_nm: "-" },
    list: [],
  },
  depth3: {
    selected: { up_class_id: "", class_id: "", class_nm: "-" },
    list: [],
  },
  searchParams: {
    rev_id: "",
    enable_yn: "",
    up_class_id: "",
  },
  rootId: "",
  tmpList: [],
  searchDepth: 1,
  revidList: [],
});

const canUpdate = computed(()=>{
    return common.checkAccessAuth('M005M001')
})

//api response 트리형식으로 배열 재구성(root 탐색 함수)
const getList = async () => {
  try {
    setIsLoading(true)
    //상품분류체계 List api 호출
    state.searchParams.rev_id = state.revSelect.selected
    const res = await prodList(state.searchParams)
    state.rootId = state[`depth${state.curDepth}`].selected.up_class_id

    state.originList = [...res.rtn]
    if (state.firstLoad) {
      state.originList.forEach((item) => {
        if (item.up_class_id === '') {
          //검색조건 리스트
          let depthItem = {
            class_nm: item.class_nm,
            class_id: item.class_id,
            up_class_id: item.up_class_id,
          };
          state.depth1.list.push(depthItem);
        }


      })
    }
    state.updateCheck = false;
    state.firstLoad = false;
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }

};


//공유하기
// const shareToUser = () => {
//   openEmailSend();
// }

/** 메일발송 모달 (3.팝업오픈) */
// const openEmailSend = () => {
//   //메일정보 초기값
//   const emailParams = {
//     call_prgm_id: 'MIM_CL_002',
//     call_prgm_nm: '상품 분류체계 조회/수정',
//     receiver_ids: '',
//     receiver_nms: '',
//     title: '상품 분류체계 정보 공유드립니다.',
//     content: makeEmailContent()
//   };

//   emailSendModalRef.value.openEmailModal(emailParams);
// };

// /** 메일발송 모달 (4.메일내용) */
// const makeEmailContent = () => {
//   //선택된 상품 분류체계 목록
//   let prodclass = [];
//   let selectRows = treeTableRef.value.selectRows

//   if(selectRows?.length > 0) {
//     prodclass = state.originList.filter((item) => {
//       for (let i of selectRows) {
//         if (i == item.class_id) {
//           return item;
//         }
//       }
//     });
//   }

//   //메일 내용 만들기
//   let content = '';
//   for (let prod of prodclass) {
//     content += `<b>상품명: ${prod.class_nm}</b>, 활성화여부: ${prod.enable_yn}, 메모: ${prod.note}, <br/>`;
//   }
//   return content;
// }

// 임영우 : 수정 기능 막음 / 주석 처리 해놓았음 => 지워도 괜찮으면 지워주세요!
// //수정 , 등록완료 클릭 실행 함수
// const save = async () => {
//   let msg = "등록하시겠습니까?";
//   let successCnt = 0;
//   let strCheck = true;
//   let selectRows = treeTableRef.value.selectRows
//   //선택한 값(키값)으로 리스트에서 row 정보 추출
//   let selectRowData = state.originList.filter((item) => {
//     for (let i of selectRows) {
//       // console.log("test===>"+common.checkSpecChar(item.note))
//       if (i == item.class_id) {
//         if (common.checkSpecChar2(item.note) || common.checkSpecChar2(item.class_nm)) {
//           alert('특수문자는 입력할 수 없습니다\n확인 후 입력해 주세요.')
//           strCheck = false
//           getList();
//           return false
//         } else {
//           return item;
//         }
//       }
//     }
//   });

//   if (strCheck) {
//     try {
//       if (confirm(msg)) {
//         for (let param of selectRowData) {
//           await prodEdit(param)
//           successCnt += 1;
//         }
//       }
//       alert(
//         "총 " +
//         selectRowData.length +
//         "건 중에 " +
//         successCnt +
//         "건을 성공했습니다."
//       );
//     } catch (e) {
//       console.log(e);
//       alert(
//         "총 " +
//         selectRowData.length +
//         "건 중에 " +
//         successCnt +
//         "건을 성공했습니다."
//       );
//     } finally {
//       treeTableRef.value.selectRows = []
//       getList();
//     }
//   }
//   //getList();

// };

//리비전 list 조회
const getRevList = async () => {
  try {
    setIsLoading(true)
    const res = await getProdRevIdList()
    state.revSelect.list = res.rtn;
    state.revSelect.selected = res.rtn[0].rev_id;
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
};

//엑셀 다운로드
const excelDown = async() => {
  try{
    setIsLoading(true)
    state.excelData = []
    let fileNm = "상품분류체계 리스트";
    let header = [state.excelGridColumn1,[]];
    let headerProps = []

    let tmpHeaderProps = [
      "rev_id",
      "class_id",
      "enable_yn",
      "note",
      "fmt_reg_dt",
      "reg_user_nm",
      "fmt_upd_dt",
      "upd_user_nm",
      

    ]
    let maxDepth = 3
    let param = {
      rev_id: state.revSelect.selected,
    };
    const res = await prodList(param)
    state.prodList = [...res.rtn]
    const prodDataList = [...res.rtn].map((item)=>{
      let codeFam = common.findUperCode(item.class_id,[...res.rtn]) || []
      if(codeFam.length > 0){
        codeFam.forEach((itemCode, index) =>
          item[`class_nm${index + 1}`] = itemCode.class_nm 
        )
        if(codeFam.length > maxDepth) maxDepth = codeFam.length
        return item
      }
    });

    const rootList = []

    prodDataList.filter(item => item.up_class_id === '').forEach((parentItem)=>{
      let row = {
        key: parentItem['class_id'],
        data: parentItem,
      };
      rootList.push(row);
      
    })
    rearrange(rootList)

    rootList.forEach((data)=>{
      state.excelData.push(data.data)
      if(data.children?.length > 0){
        findChildren(data.children)
      }
    })



    for(var i=1; i<=maxDepth; i++){
      headerProps.push(`class_nm${i}`)
      header[1].push({header : `${i}단계`,rowspan : 1,colspan : 1})
    }
    headerProps = [...headerProps,...tmpHeaderProps]
    header[0].colspan = maxDepth


    excelUtilRef.value.excelDownload(fileNm, [...header], [...state.excelData],[...headerProps]);
  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }

};

//child depth 계속 생성
const rearrange = (rootList) => {
    rootList.forEach((item)=>{
      let childTree = [];
      state.prodList.forEach((i) => {
        if (i.up_class_id === item.key) {
          let row = {
            key: i.class_id,
            data: i,
          };
          childTree.push(row);
        }
      });

      if (childTree?.length > 0) {
        item.children = childTree;
        rearrange(childTree);
      }
    })
};

function findChildren(childList){
  [...childList].forEach((child)=>{
    state.excelData.push(child.data)
    if(child.children?.length > 0){
      findChildren(child.children)
    }
  })
}


const nextDepth = async (item, depth) => {
  try {
    state.curDepth = depth
    let param = {
      rev_id: state.revSelect.selected,
    };
    const res = await prodList(param)
    let prodRes = [...res.rtn]
    if (item && item != undefined && item != null) {
      state["depth" + depth].selected = item;
      if (depth != 3) {
        //하위 depth 검색조건 초기화
        for (let i = depth + 1; i < 4; i++) {
          let depthNum = "depth" + Number(i);
          let parentDepthNum = "depth" + Number(i - 1);
          state[depthNum].list = [
            {
              up_class_id: state[parentDepthNum].selected.up_class_id,
              class_id: state[parentDepthNum].selected.class_id,
              class_nm: "-",
            },
          ];
          state[depthNum].selected = {
            up_class_id: state[parentDepthNum].selected.up_class_id,
            class_id: state[parentDepthNum].selected.class_id,
            class_nm: "-",
          };
        }
        //전체 선택시에는 다음 단계 list 생성 x
        if (item.class_nm != "All" || item.class_nm != "-") {
          //다음 자식 depth item 생성
          let depthNm = "depth" + Number(depth + 1);
          for (let i of prodRes) {
            if (i.up_class_id == item.class_id) {
              state[depthNm].list.push(i);
            }
          }
        }
      }

      if (item.class_nm != "All" || item.class_nm != "-") {
        state.searchDepth = depth;
      } else {
        if (depth != 1) {
          state.searchDepth = depth - 1;
        } else {
          state.searchDepth = depth;
        }
      }
      state.searchParams.up_class_id = item.class_id;
    }
  } catch (err) {
    console.error(err)
  }

};

const clearRow = () => {
  state.gridRowData = [];
};

const customCapture = () => {
  capture();
};


//셀 수정 완료시
const onCellEditComplete = (slotProps) => {

  state.originList = state.originList.map((item) => {
    if (item.class_id === slotProps.node.key) {
      item.editCell = new Object()
      item[slotProps.column.key] = slotProps.node.data[slotProps.column.key]
      let checkExist = treeTableRef.value.selectRows.filter(treeItem => treeItem === item.class_id)
      if (checkExist.length === 0) {
        treeTableRef.value.selectRows.push(item.class_id)
      }
    }

    return item
  })
};


const editCell = (obj) => {
  state.originList = state.originList.map((item) => {
    if (item.class_id === obj.key) {
      item.editCell = new Object()
      item.editCell[obj.col] = true
    }
    return item
  })
};

//이전버튼 클릭
const goBack = () => {
  if (state.updateCheck) {
    let msg = "저장되지 않은 데이터가 있습니다.뒤로 가시겠습니까?";
    if (confirm(msg)) {
      routerCmn.goBack();
    }
  } else {
    routerCmn.goBack();
  }
};

</script>
